import React, { useCallback, useMemo, useState } from "react";
import { FileWithPath, useDropzone } from "react-dropzone";
import { v4 as uuid } from "uuid";
import { uploadFileCpfErrors } from "../contracts/upload-file-cpf";
import { uploadFileErrors } from "../contracts/upload-file";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column" as "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const MAX_SIZE = 5242880;
//const MAX_SIZE = 20;
const fileValidator = (file) => {
  if (file.size > MAX_SIZE) {
    return {
      code: "size-too-large",
      message: `o arquivo é maior que 5MB`,
    };
  }

  return null;
};

interface Props {
  onFileUploaded: (file: File) => void;
  errorUpload?: uploadFileCpfErrors;
  errorUploadCnpj?: uploadFileErrors;
}

const Basic: React.FC<Props> = ({ onFileUploaded, errorUpload }) => {
  const [selectedFileUrl, setSelectFileUrl] = useState("");

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        const fileUrl = URL.createObjectURL(file);

        setSelectFileUrl(fileUrl);

        onFileUploaded(file);
      }
    },
    [onFileUploaded]
  );

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
  } = useDropzone({
    accept: { "text/csv": [] },
    validator: fileValidator,
    multiple: false,
    onDrop,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const acceptedFileItem = acceptedFiles.map((file: FileWithPath) => (
    <li key={uuid()}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItem = fileRejections.map(({ errors }) => (
    <ul>
      {errors.map((e) => (
        <li key={uuid()}>{e.message}</li>
      ))}
    </ul>
  ));

  return (
    <div className="container">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />

        {errorUpload ? (
          <>
            <h4 className="mb-4">
              Ocorreu errou durante o envio:{" "}
              <span className="italic md:not-italic">
                {errorUpload.message}
              </span>
              , por favor tente novamente.
            </h4>
            {acceptedFileItem.length > 0 ? (
              <>
                <h4>Novo arquivo selecionado</h4>
                <ul>{acceptedFileItem}</ul>
              </>
            ) : null}
          </>
        ) : null}
        {!selectedFileUrl && fileRejectionItem?.length === 0 && !errorUpload ? (
          <>
            <p>
              Arraste e solte o arquivo aqui ou clique para selecionar o arquivo
            </p>
          </>
        ) : null}
        {selectedFileUrl && !errorUpload ? (
          <>
            <h4>Arquivo selecionado</h4>
            <ul>{acceptedFileItem}</ul>
          </>
        ) : null}
        {fileRejectionItem?.length > 0 ? (
          <>
            <h4>Arquivo Rejeitado</h4>
            <b>{fileRejectionItem}</b>
            <h4>selecionar um arquivo válido</h4>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Basic;
